module.exports = __webpack_public_path__ + "img/step-image1.4c317748.jpg";